import { THREE } from '../stream-particle-system/v3d';

const dir = new THREE.Vector3();

export const computeDirectionIn3D = (p1: THREE.Vector3, p2: THREE.Vector3) =>
  dir.copy(p2).sub(p1);
